import {Product} from "../model/types";

export const getUrl = (product: Product) => `/catalog/product/${product.article}`;
